var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.7792 49.8896C99.7792 22.3363 77.4429 0 49.8896 0C22.3363 0 0 22.3363 0 49.8896V49.892C0 77.4453 22.3363 99.7816 49.8896 99.7816C77.4429 99.7816 99.7792 77.4453 99.7792 49.892V49.8896Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6919 49.8851C88.6919 28.4548 71.3192 11.082 49.8889 11.082C28.4586 11.082 11.0859 28.4548 11.0859 49.8851V49.887C11.0859 71.3173 28.4586 88.6899 49.8889 88.6899C71.3192 88.6899 88.6919 71.3173 88.6919 49.887V49.8851Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0501 33.043C47.1311 28.03 54.0881 28.03 56.1691 33.043L57.6191 36.5339C58.4711 38.5869 60.3421 40.0099 62.5121 40.2559L66.5571 40.715C71.6661 41.294 73.7751 47.7089 70.0451 51.3189L66.6101 54.6429C65.1001 56.1039 64.4331 58.2559 64.8441 60.3379L65.6731 64.5359C66.7231 69.8489 61.0311 73.8609 56.5381 70.9739L53.8251 69.2309C51.8601 67.9679 49.3591 67.9679 47.3931 69.2309L44.6811 70.9739C40.1881 73.8609 34.4961 69.8489 35.5451 64.5359L36.3741 60.3379C36.7861 58.2559 36.1181 56.1039 34.6081 54.6429L31.1741 51.3189C27.4431 47.7089 29.5531 41.294 34.6611 40.715L38.7061 40.2559C40.8771 40.0099 42.7481 38.5869 43.6001 36.5339L45.0501 33.043Z",
    fill: "black",
    fillOpacity: 0.15,
    stroke: "black",
    strokeWidth: 5.45039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 10.419,
    y1: 4.388,
    x2: 105.2,
    y2: 25.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.ab4e2051bdac37bf4c298cad05b94cfa.svg";
export { ForwardRef as ReactComponent };